import { Spinner } from "@heroui/react";
import "./AnimatedButton.css";
import { ArrowRight } from "lucide-react";

const AnimatedButton = ({ loading = false, onClick, title }) => {
  return (
    <button className="ab-button-wrapper w-full h-11" onClick={onClick}>
      <div className="ab-download-btn">
        <div className="ab-hover-bg"></div>
        {loading ? (
          <Spinner />
        ) : (
          <span className="ab-text items-center">
            {title}
            <ArrowRight size={19} />
          </span>
        )}
      </div>
    </button>
  );
};

export default AnimatedButton;
